module.exports = __webpack_public_path__ + "static/media/img_signin_bg_logo.ccdb2a13.webp";